// extracted by mini-css-extract-plugin
export var animationContainer = "_gr-0";
export var asteriskIcon = "_gr-8";
export var conversationLeftSection = "_gr-4";
export var conversationListItem = "_gr-3";
export var conversationMiddleSection = "_gr-5";
export var conversationRightSection = "_gr-6";
export var detailsContent = "_gr-1";
export var listContainer = "_gr-7";
export var modalContent = "_gr-2";